import * as moment from "moment";
import * as React from "react";
import { IGoalDataPoint } from "motw_core/Entity/IGoalDataPoint";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function GetLastTimeText({
    startDateValue,
    datapoints,
}: {
    startDateValue: string;
    datapoints: IGoalDataPoint[];
}) {
    const lastDatapoint = datapoints.length > 0 ? datapoints[0] : undefined;

    if (!lastDatapoint) {
        return null;
    }

    const startDateMoment = moment(startDateValue);
    const lastModifiedTimeMoment = moment(lastDatapoint.lastmodifiedtime);

    const moreRecentDate = startDateMoment.isAfter(lastModifiedTimeMoment)
        ? startDateMoment
        : lastModifiedTimeMoment;

    const formattedDate = moreRecentDate.format("DD MMM YYYY");
    const daysAgoText = moment(moreRecentDate).fromNow();

    return (
        <div
            className={StyleClassAuto({
                marginTop: "5px",
                opacity: 0.4,
                marginBottom: "3px",
                fontSize: "12px",
            })}
        >
            last: {formattedDate} - {daysAgoText}
        </div>
    );
}
